import { STATUS_LABEL } from "@/lib/format";
import { useTranslation } from "react-i18next";
import { LogOut, DoorOpen, BedDouble, AlertTriangle } from "lucide-react";

const ICONS = {
  departing: DoorOpen,
  in_house: BedDouble,
  due: AlertTriangle,
};

export function StatusBadge({ status, priority, size = "sm" }) {
  const { t } = useTranslation();
  const Icon = ICONS[status] || BedDouble;
  const cls = priority ? "status-priority" : `status-${status}`;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-md border font-semibold ${cls} ${pad}`}
    >
      <Icon className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />
      {t(STATUS_LABEL[status] || status)}
    </span>
  );
}

export function PriorityBadge({ size = "sm" }) {
  const { t } = useTranslation();
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid="priority-badge"
      className={`inline-flex items-center gap-1.5 rounded-md border font-bold status-priority ${pad}`}
    >
      <LogOut className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />
      {t("Due — Priority")}
    </span>
  );
}
